var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2609541_facebook_media_social_icon 4",
    clipPath: "url(#clip0_0_3712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 23.2676C30 26.9883 26.9824 30 23.2676 30H6.73242C3.01758 30 0 26.9824 0 23.2676V6.73242C0 3.01758 3.01758 0 6.73242 0H23.2676C26.9824 0 30 3.01758 30 6.73242V23.2676Z",
    fill: "#4F76BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5195 9.65033C18.0234 9.63276 18.5273 9.64447 19.0312 9.64447C19.0898 9.64447 19.1543 9.64447 19.2363 9.64447V7.02533C18.9668 6.99604 18.6855 6.96088 18.4043 6.94916C17.8887 6.92572 17.373 6.90229 16.8516 6.91401C16.0605 6.93158 15.3164 7.12494 14.666 7.58783C13.916 8.1269 13.5059 8.88276 13.3535 9.77338C13.2891 10.1425 13.2715 10.5234 13.2598 10.8984C13.248 11.4843 13.2598 12.0703 13.2598 12.6621V12.8847H10.7578V15.8085H13.248V23.1562H16.2891V15.8144H18.7734C18.9023 14.8417 19.0254 13.8808 19.1543 12.8788C18.9551 12.8788 18.7734 12.8788 18.5977 12.8788C17.8887 12.8847 16.2715 12.8788 16.2715 12.8788C16.2715 12.8788 16.2773 11.4316 16.2949 10.7988C16.3184 9.93744 16.834 9.67377 17.5195 9.65033Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfacebook);
export default __webpack_public_path__ + "static/media/pfacebook.7e541f278a3c2df205e520b923a7fdee.svg";
export { ForwardRef as ReactComponent };